import React from "react";
import { func, number, object } from "prop-types";
import { useDispatch } from "react-redux";
import MapShape from "components/MapShape/ForInitialSetup";
import * as actionTypes from "store/actions/actionTypes";
import { deviceFloorLevel, floorCode } from "config/constants";
import { cacheItem } from "utils/localStorage";

SettingChooseFloor.propTypes = {
  styles: object,
  changeFloor: func,
  mapLevel: number,
};

function SettingChooseFloor(props) {
  const { changeFloor, mapLevel } = props;

  const defaultProps = {
    name: deviceFloorLevel,
    className: "form-control col-md-3",
    onChange: (e) => {
      changeFloor(+e.target.value);
    },
    defaultValue: mapLevel,
  };
  const dispatch = useDispatch();

  const selectDeviceFloorLevel = (deviceFloorLevel, mapLevel) => {
    cacheItem(deviceFloorLevel, mapLevel);
    dispatch({
      type: actionTypes.SET_DEVICE_FLOOR_LEVEL,
      payload: floorCode[+mapLevel],
    });
  };

  return (
    <div>
      <div className="form-row">
        <select {...defaultProps}>
          <option value="1" disabled>
            Chọn tầng
          </option>
          <option value="1">Tầng 1</option>
          <option value="2">Tầng 2</option>
          <option value="3">Tầng 3</option>
        </select>
        <button
          className="btn btn-primary ml-3"
          type="button"
          onClick={() => selectDeviceFloorLevel(deviceFloorLevel, mapLevel)}
        >
          Submit{" "}
        </button>
      </div>
      <div className={props.styles.map_container}>
        {/* In this container we only have one pin to show */}
        <MapShape floorIndex={mapLevel} />
      </div>
    </div>
  );
}

export default SettingChooseFloor;
